import * as Yup from 'yup';
import { CommonMessages } from 'src/validation/CommonMessages';

const UserValidationSchema = Yup.object().shape({
  icon_num: Yup.number()
    .nullable() // Allow null values
    .transform((originalValue) => {
      const parsedValue = originalValue === '' || isNaN(originalValue) ? null : Number(originalValue);
      return parsedValue;
    })
    .required(CommonMessages.required('Icon')),

  login_id: Yup.string()
    .required(CommonMessages.required('LoginID')),

  password: Yup.string()
    .when('id', {
      is: (id) => id === '0',
      then: function (schema) {
        return schema.required(CommonMessages.required('Password'));
      },
      otherwise: (schema) => schema
        .when('changePassword', {
          is: (changePassword) => changePassword,
          then: (schema) => schema.required(CommonMessages.required('Password')),
          otherwise: (schema) => schema.notRequired(),
        })
    }),

  name: Yup.string()
    .required(CommonMessages.required('Name')),


  jp_time_conversion_factor: Yup.number()
  .required(CommonMessages.required('JP Time Conversion Factor'))
  .typeError('JP Time Conversion Factor')
  .min(0, 'JP Time Conversion Factor must be at least 0'),

  email: Yup.string()
    .email(CommonMessages.email())
    .required(CommonMessages.required('Mail Address')),

  status_cd: Yup.string()
    .required(CommonMessages.required('Status')),

  auth_cd: Yup.string()
    .required(CommonMessages.required('Authority')),

  department_cd: Yup.string()
    .required(CommonMessages.required('Department')),

  working_hours_cd: Yup.string()
    .required(CommonMessages.required('Core time')),

  hire_date: Yup.date()
    .nullable()
    .required(CommonMessages.required('Hire date'))
    .transform((originalValue) => {
        if (originalValue === '') return null;
        const parsedDate = new Date(originalValue);
        if (isNaN(parsedDate)) return null;
        return parsedDate;
    }),

  retirement_date: Yup.date()
    .nullable()
    .transform((originalValue) => {
        if (!originalValue) return null;
        const parsedDate = originalValue instanceof Date 
            ? originalValue
            : new Date(originalValue);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
    })
    .min(
        Yup.ref('hire_date'),
        CommonMessages.after('Retirement date', 'hire date')
    )
});

export default UserValidationSchema;
